import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { fetchCurrentFiling } from "../../../../../api/filings/filingAPI";
import Dashboard from "../../Dashboard";
import { useRefreshOnAuth } from "../../../../../hooks/useRefreshOnAuth";

function FilingLayout() {
  const { filingUuid } = useParams();
  const [filing, setFiling] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshFilingData = async () => {
    try {
      const response = await fetchCurrentFiling(
        "tax/filing",
        filingUuid,
        "overview",
        { includeMetrics: true },
      );
      if (response.ok) {
        const data = await response.json();
        setFiling(data);
      }
    } catch (err) {
      console.error("Layout fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // This side effect is used for: (a) Refresh page (b) When render the page for first
  useRefreshOnAuth(refreshFilingData);

  useEffect(() => {
    refreshFilingData();
  }, [filingUuid]);

  return (
    <div className="main-content-area">
      <Dashboard
        service="TX"
        matchedCpa={filing?.matched_cpa}
        loading={loading}
      />

      <div className="content">
        {/* Outlet passes the 'filing' data down so children 
           don't have to fetch it again. 
        */}
        <div className="internal-content-body">
          <Outlet context={{ filing, setFiling, refreshFilingData, loading }} />
        </div>
      </div>
    </div>
  );
}

export default FilingLayout;
